$(function () {
    $(".we-prijava-form-container .cf7-views-table thead tr").prepend(`<th>No.</th>`);
    $(".we-prijava-form-container .cf7-views-table tbody tr").each(function (index, element) {
			// element == this
            $(element).prepend(`<td style="text-align:center;">${(index+1)}</td>`);
		});

    
    //WP EVENTS
    $(
			`<a href="/kalendar" class="eventitem-backlink" id="yui_3_17_2_1_1674384059206_350">Povratak na kalendar</a>`
		).prependTo(".we-single-event-page .btx-post-content");

});

